import { create } from "zustand";

export type Theme = "dark" | "light" | "zinc";

const STORAGE_KEY = "agnt-theme";
const THEMES: Theme[] = ["dark", "light", "zinc"];

function getInitialTheme(): Theme {
	const stored = localStorage.getItem(STORAGE_KEY);
	if (stored && THEMES.includes(stored as Theme)) return stored as Theme;
	return "dark";
}

function applyTheme(theme: Theme) {
	if (theme === "dark") {
		document.documentElement.removeAttribute("data-theme");
	} else {
		document.documentElement.setAttribute("data-theme", theme);
	}
	localStorage.setItem(STORAGE_KEY, theme);
}

interface ThemeState {
	theme: Theme;
	setTheme: (theme: Theme) => void;
	cycleTheme: () => void;
}

export const useThemeStore = create<ThemeState>((set, get) => ({
	theme: getInitialTheme(),
	setTheme: (theme) => {
		applyTheme(theme);
		set({ theme });
	},
	cycleTheme: () => {
		const current = get().theme;
		const idx = (THEMES.indexOf(current) + 1) % THEMES.length;
		const next: Theme = THEMES[idx] ?? "dark";
		applyTheme(next);
		set({ theme: next });
	},
}));

// Apply theme immediately on import
applyTheme(getInitialTheme());
